module.exports = __webpack_public_path__ + "static/img/rectangle04.eacc20d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/psLock/rectangle/rectangle04.jpg
// module id = 0obX
// module chunks = 0